import type { CSSProperties } from "react";

type LibraryThemeStyle = CSSProperties & Record<`--${string}`, string>;

export function uiLibraryThemeStyle(): LibraryThemeStyle {
  return {
    "--background": "var(--fintheon-bg)",
    "--foreground": "var(--fintheon-text)",
    "--card": "var(--fintheon-surface)",
    "--card-foreground": "var(--fintheon-text)",
    "--popover": "var(--fintheon-surface)",
    "--popover-foreground": "var(--fintheon-text)",
    "--primary": "var(--fintheon-primary, var(--fintheon-accent))",
    "--primary-foreground": "var(--fintheon-bg)",
    "--secondary": "var(--fintheon-surface)",
    "--secondary-foreground": "var(--fintheon-text)",
    "--muted": "var(--fintheon-muted)",
    "--muted-foreground":
      "color-mix(in srgb, var(--fintheon-text) 58%, transparent)",
    "--accent": "var(--fintheon-accent)",
    "--accent-foreground": "var(--fintheon-bg)",
    "--border":
      "color-mix(in srgb, var(--fintheon-surface) 88%, var(--fintheon-text) 12%)",
    "--ring": "var(--fintheon-primary, var(--fintheon-accent))",
    "--radius": "var(--fintheon-radius, 0.5rem)",
  };
}
